import { Component, OnInit } from '@angular/core';
import {
  ServicioComprobanteInformeService,
  EntidadEmpresarial,
  InformacionUsuario,
  InformacionComprobante,
  FiltroComprobanteInforme,
  ResumenServicio,
  ListaComprobantesUsuario,
  SumaComprobantesUsuario,
  TotalSumaComprobantes,
  SumaResumenServicio
} from '../../services/servicio-comprobante-informe.service';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertModel, ETipoAlert } from '../shared/alert/alert.component';
import { ExcelService } from 'src/app/services/utils/excel.service';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-reporte-comprobante-informe-diario-dian',
  templateUrl: './reporte-comprobante-informe-diario-dian.component.html',
  styleUrls: ['./reporte-comprobante-informe-diario-dian.component.css']
})
export class ReporteComprobanteInformeDiarioDianComponent implements OnInit {

  loading: boolean = true;
  errorAlert: AlertModel = new AlertModel;
  now = new Date();

  filtro: FiltroComprobanteInforme;
  listaComprobantes: InformacionComprobante[];
  listaComprobantesUsuario: ListaComprobantesUsuario;
  sumaComprobantesUsuario: SumaComprobantesUsuario;
  sumaTotalComprobantes: TotalSumaComprobantes;

  resumenServicios: ResumenServicio[];
  sumaResumenServcios: SumaResumenServicio = new SumaResumenServicio;

  entidadEmpresarial: EntidadEmpresarial;
  usuario: InformacionUsuario;

  constructor(private activatedRoute: ActivatedRoute,
    private servicioComprobanteInforme: ServicioComprobanteInformeService,
    private datePipe: DatePipe,
    private servicioExcel: ExcelService
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.filtro = {
        codigoBaseDatos: params['codigoBaseDatos'],
        fecha: new Date(),
        uncoLogin: params['uncoLogin'],
        uncoSede: params['uncoSede']
      }
    });
  }

  ngOnInit() {
    this.getEntidadEmpresarial();
    this.getInfoComprobantes();
  }

  applyFilter(filtro) {
    this.filtro = filtro;
    this.loading = true;
    this.getInfoComprobantes();
  }

  errorRequest(mensaje: string) {
    this.errorAlert = {
      mensaje,
      tipo: ETipoAlert.danger,
      visible: true
    }
    this.eventError(this.errorAlert);
  }

  eventError(errorAlert: AlertModel) {
    this.loading = false;
    this.errorAlert = errorAlert;
  }

  async getEntidadEmpresarial() {
    try {
      const response = await this.servicioComprobanteInforme.getEntidadEmpresarial(this.filtro);
      if (response != null) {
        response.subscribe((data: any) => {
          if (data && Array.isArray(data) && data.length > 0) {
            data = data[0];
            const entidad: EntidadEmpresarial = {
              identificacionTributaria: data.identificacionTributaria,
              digitoVerificacion: data.digitoVerificacion,
              descripcion: data.descripcion,
              direccion: data.direccion,
              telefono: data.telefono,
              logoUrl: data.urlLogo,
              codigoPrestador: data.codigoPrestador,
            };
            this.entidadEmpresarial = entidad;
            this.getInformacionUsuario();
          }
        }, (err: HttpErrorResponse) => {
          this.errorRequest('Error grave al obtener la entidad empresarial, reporte caso al administrador')
          console.log('Error entidad Empresarial', err);
        });
      }
    } catch (e) {
      this.loading = false;
      console.log(e);
    }
  }

  async getInformacionUsuario() {
    try {
      const response = await this.servicioComprobanteInforme.getInformacionUsuario(this.filtro);
      if (response != null) {
        response.subscribe((data: any) => {
          data = data[0];
          this.usuario = {
            nombreUsuario: data.nombreUsuario,
            codigoBarrasImprime: data.codigoBarrasImprime,
          };
        }, (err: HttpErrorResponse) => {
          this.errorRequest('Error grave al obtener la informacion del usuario, reporte caso al administrador')
          console.log('Error Info usuario', err);
        });
      }
    } catch (e) {
      this.loading = false;
      console.log(e);
    }
  }

  async getInfoComprobantes() {
    let response = await this.servicioComprobanteInforme.getInformacionComprobantes(this.filtro);
    if (response != null) {
      response.subscribe((data: InformacionComprobante[]) => {
        //Se reinician los valores
        if (data.length === 0) {
          this.listaComprobantes = [];
          this.listaComprobantesUsuario = {} as ListaComprobantesUsuario;
          this.sumaComprobantesUsuario = {} as SumaComprobantesUsuario;
          this.sumaTotalComprobantes = {} as TotalSumaComprobantes;
          this.resumenServicios = [];
          this.sumaResumenServcios = new SumaResumenServicio;
          this.loading = false;
          return;
        }

        this.listaComprobantes = data;
        this.listaComprobantesUsuario = this.groupComprobanteByUsers(data);

        //Funcion que realiza la suma de una lista de comprabantes
        const functionReduceSuma = (accumulator, comprobante) => {
          const { valorServicioDetalle, valorSuministroDetalle, valorIva,
            valorFormaPagoDetalle, valorEpsDetalle } = comprobante;

          accumulator['totalValorServicios'] = valorServicioDetalle + (accumulator['totalValorServicios'] || 0);
          accumulator['totalValorSuministros'] = valorSuministroDetalle + (accumulator['totalValorSuministros'] || 0);
          accumulator['totalValorFactura'] = (valorServicioDetalle + valorSuministroDetalle) + (accumulator['totalValorFactura'] || 0);
          accumulator['totalDescuentos'] = valorServicioDetalle + (accumulator['totalDescuentos'] || 0);
          accumulator['totalEfectivo'] = valorFormaPagoDetalle + (accumulator['totalEfectivo'] || 0);
          accumulator['totalVentasCredito'] = valorEpsDetalle + (accumulator['totalVentasCredito'] || 0);
          accumulator['totalValorIva'] = valorIva + (accumulator['totalValorIva'] || 0);
          return accumulator;
        }

        //Se realiza la suma de los valores separados por cada usuario
        this.sumaComprobantesUsuario = Object.keys(this.listaComprobantesUsuario).reduce((prevVal, currentVal) => {
          const sumaComprobantes = this.listaComprobantesUsuario[currentVal].reduce(functionReduceSuma, {});
          prevVal[currentVal] = sumaComprobantes
          return prevVal;
        }, {});

        //Se realiza la suma total de todos los comprobantes
        this.sumaTotalComprobantes = data.reduce(functionReduceSuma, {} as TotalSumaComprobantes);


        this.getResumenServicio();
      }, (err: HttpErrorResponse) => {
        console.error('Error Informacion comprobrantes', err);
        this.errorRequest('Error grave al obtener la informacion de los comprobantes, reporte caso al administrador')
      });
    }
  }

  //Agrupa los comprobantes por cada usuario
  groupComprobanteByUsers = (comprobrantes: InformacionComprobante[]): ListaComprobantesUsuario => {
    const listaComprobantes: ListaComprobantesUsuario = comprobrantes.reduce((prevValue, currentValue) => {
      const val = currentValue['usuario'];
      prevValue[val] = (prevValue[val] || []).concat(currentValue);
      return prevValue;
    }, {});
    return listaComprobantes;
  }

  async getResumenServicio() {
    let response = await this.servicioComprobanteInforme.getResumenServicio(this.filtro);
    if (response != null) {
      response.subscribe((data: any[]) => {
        this.loading = false;
        this.resumenServicios = data.map((servicios: any) => {
          this.sumaResumenServcios.iva += servicios.parcial_iva;
          this.sumaResumenServcios.valorTotal += servicios.vlr_total;
          this.sumaResumenServcios.valorTotalG += servicios.vlr_totalG;
          return ({
            codigoLinea: servicios.cod_linea,
            lineaProducto: servicios.linea_producto,
            cantidad: servicios.cntdd,
            valorTotal: servicios.vlr_total,
            parcialIva: servicios.parcial_iva,
            valorPorcentaje: servicios.vlr_prcntje,
            valorTotalG: servicios.vlr_totalG
          })
        });
      }, (err: HttpErrorResponse) => {
        console.error('Error Informacion comprobrantes', err);
        this.errorRequest('Error grave al obtener el resumen de los servicios, reporte caso al administrador')
      })
    }
  }

  generarCsv() {
    const jsonCsv = {
      row1: {
        header: ['usuario', 'equipo', 'forma pago', 'consecutivo', 'fecha', 'Vlr Servicios',
          'Vlr Suministros', 'Vlr Factura', 'Descuentos', 'Efectivo', 'Ventas a Credito', 'Estado', 'Vlr iva %'],
        body: []
      },
      row2: {
        header: ['Cons Inicial', 'Cons Final', 'Vlr Servicios', 'Vlr Suministros', 'Vlr Factura', 'Descuentos',
          'Efectivo', 'Ventas a Credito', 'Estado', 'Vlr iva %'],
        body: []
      },
      row3: {
        header: ['cod linea', 'linea producto', '% Iva', 'Cantidad', 'Valor total', 'Iva', 'vlr total G'],
        body: []
      }
    }

    //Lista de comprobantes
    Object.values(this.listaComprobantesUsuario)
      .sort((a: InformacionComprobante[], b: InformacionComprobante[]) => {
        return (a[0].usuario.localeCompare(b[0].usuario) || 0);
      })
      .forEach(comprobantesUsuario => {
        comprobantesUsuario.forEach(comprobante => {
          let data = {
            usuario: comprobante.usuario,
            equipo: comprobante.equipo,
            formaPago: comprobante.formaPago,
            consecutivo: comprobante.consecutivo,
            fecha: this.datePipe.transform(comprobante.fecha, 'dd/MM/yyyy'),
            valorServi: comprobante.valorServicioDetalle,
            valorSuminis: comprobante.valorSuministroDetalle,
            valorFact: comprobante.valorServicioDetalle + comprobante.valorSuministroDetalle,
            descuentos: 0,
            efectivo: comprobante.valorFormaPagoDetalle,
            ventasCredito: comprobante.valorEpsDetalle,
            estado: comprobante.estadoRegistro,
            valorIva: comprobante.valorIva
          }
          jsonCsv.row1.body.push(data);
        })
      });

    //Resumen de facturas por resolucion
    jsonCsv.row2.body = [{
      consecutivoIni: this.listaComprobantes[0].consecutivo,
      consecutivoFin: this.listaComprobantes[this.listaComprobantes.length - 1].consecutivo,
      totalServ: this.sumaTotalComprobantes.totalValorServicios,
      totalSumin: this.sumaTotalComprobantes.totalValorSuministros,
      valorFac: (this.sumaTotalComprobantes.totalValorFactura || 0),
      descuentos: 0,
      valorEfectivo: this.sumaTotalComprobantes.totalEfectivo,
      ventasCredito: this.sumaTotalComprobantes.totalVentasCredito,
      estado: this.listaComprobantes[0].estadoRegistro,
      totalIva: this.sumaTotalComprobantes.totalValorIva,
    }]

    //Resumen por servicio
    jsonCsv.row3.body = this.resumenServicios.map(servicio => {
      return {
        codigo: servicio.codigoLinea,
        linea: servicio.lineaProducto,
        porcentaje: servicio.valorPorcentaje,
        cantidad: servicio.cantidad,
        valorTotal: servicio.valorTotal,
        parcialIva: servicio.parcialIva,
        total: servicio.valorTotalG
      }
    })

    let datos = Object.keys(jsonCsv).map(headKey => {
      let dataRow = jsonCsv[headKey].body.map(row => {
        return Object.values(row).join(',');
      })
      dataRow.unshift(jsonCsv[headKey].header.join(','))
      let csvArray = dataRow.join('\r\n');

      return csvArray;
    });
    let csvArray = datos.join('\r\n\n');
    this.servicioExcel.exportAsCSVFile(csvArray, 'ReporteInformeDiario');

  }
}